
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { useTranslation } from "react-i18next";

interface FavoritesHeaderProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  filteredCount: number;
}

export const FavoritesHeader = ({ searchQuery, onSearchChange, filteredCount }: FavoritesHeaderProps) => {
  const { t } = useTranslation('common');
  
  return (
    <div className="mb-6 flex flex-col items-start justify-between gap-4 rounded-md border border-brand-cloud bg-white p-4 shadow-sm md:flex-row md:items-center">
      <p className="text-brand-slate">
        {t("favorites.providerCount", { 
          count: filteredCount, 
          provider: t(`favorites.provider_${filteredCount === 1 ? 'one' : 'other'}`)
        })}
      </p>
      
      <div className="flex w-full flex-col items-start gap-4 md:w-auto md:flex-row md:items-center">
        <div className="relative w-full md:w-64">
          <Input
            type="search"
            placeholder={t("favorites.searchPlaceholder")}
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            className="border-brand-cloud bg-white pl-10 text-brand-ink placeholder:text-brand-slate"
          />
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-brand-slate" />
        </div>
      </div>
    </div>
  );
};
